/* eslint-disable */

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const exportComponent = async ({ formattedData, fileName, headerMap }) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet1");

  // กำหนด header
  worksheet.columns = headerMap.map((header) => ({
    header: header.label,
    key: header.key,
    width: 20, // ปรับได้
  }));

  // ใส่ข้อมูล
  formattedData.forEach((item) => {
    worksheet.addRow(item);
  });

  // สร้างไฟล์เป็น buffer
  const buffer = await workbook.xlsx.writeBuffer();

  // ดาวน์โหลดไฟล์
  saveAs(
    new Blob([buffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    `${fileName}.xlsx`
  );
};
